<template>
<div class="side animate-box">
    <p><strong v-html="lang_detail['callback_form']" ></strong></p> <!-- Who do you need a callback from? -->
    <div class="row form-group">
        <div class="col-md-12" v-if="parseInt(callback_forms.clinical_flag)">
            <div class="col-md-1 col-sm-1 col-xs-2 div-wrap-radio">
                <input type="radio" class="form-control frm-radio" :aria-label="lang_detail['callback_counselor']" name="linkSelect" @click="setClickvar(1)">
            </div>
            <label for="name" v-html="lang_detail['callback_counselor']"  ></label> <!-- I want a callback from a counselor -->
            
        </div>
        <div class="col-md-12" v-if="parseInt(callback_forms.wellness_flag)">
            <div class="col-md-1 col-sm-1 col-xs-2 div-wrap-radio">
                <input type="radio" class="form-control frm-radio" :aria-label="lang_detail['callback_coach']" name="linkSelect" @click="setClickvar(2)">
            </div>
            <label for="name" v-html="lang_detail['callback_coach']"></label> <!-- I want a callback from a coach or wellness coach -->
        </div>
        <div class="col-md-12" v-if="parseInt(callback_forms.worklife_flag)">
            <div class="col-md-1 col-sm-1 col-xs-2 div-wrap-radio">
                <input type="radio" class="form-control frm-radio" :aria-label="lang_detail['callback_worklife']" name="linkSelect" @click="setClickvar(3)">
            </div>
            <label for="name" v-html="lang_detail['callback_worklife']"></label> <!-- I want a callback from a work life specialist -->
        </div>
        <div class="col-md-12" v-if="parseInt(callback_forms.existing_case)">
            <div class="col-md-1 col-sm-1 col-xs-2 div-wrap-radio">
                <input type="radio" class="form-control frm-radio" :aria-label="lang_detail['callback_case']" name="linkSelect" @click="setClickvar(4)">
            </div>
            <label for="name" v-html="lang_detail['callback_case']" ></label> <!-- I want a callback to discuss about an existing case -->
        </div>
        <div class="form-group">
            <button type="button" :disabled="disablefdbtn" class="btn submit btn-primary" @click="sendLink()" v-html="lang_detail['submit']"></button>
        </div>
    </div>
    
</div>    
</template>

<script>
import axios from 'axios';
export default {
    name: 'CallbacksLinkSelect',
    data(){
        return{
            lang_detail:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            FORM_ACTION_DOMAIN:this.$store.state.FORM_ACTION_DOMAIN,
            languageData:this.$store.state.languageData,
            callback_forms:[],
            disablefdbtn:true,
            selectedVal:0,
            LOCAL_HOST:this.$store.state.LOCAL_HOST,
            company_data:[]
        };        
    },
    components:{
               
    },
    mounted :function(){
        if(this.$store.state.companyDataInfo['id_customizations']=="" || this.$store.state.companyDataInfo['id_customizations']==undefined || this.$store.state.companyDataInfo['id_customizations']=='undefined'){
            this.getCompanyData();
        }
        else{
            this.company_data['id_customizations']=this.$store.state.companyDataInfo['id_customizations'];
             this.callback_forms_Check();
        } 
       
        this.getlangVar()
    },
    created:function(){
    },
    watch: {
    },
	methods:{
        setClickvar(val){ 
            this.selectedVal = val;
            this.disablefdbtn=false;
        },
        sendLink(){
            this.disablefdbtn=true;
            if(this.selectedVal == 1){
                this.web_hits('contact_counselor_clicked');
                if(parseInt(this.callback_forms.chn_url)){
                    window.location.assign(this.LOCAL_HOST+'/forms/contact_counselor_chn?m=9020&e=114');
                } else {
                    window.location.assign(this.LOCAL_HOST+'/forms/contact_counselor?m=9020&e=114');
                }
            } else if(this.selectedVal == 2){
                this.web_hits('contact_wellness_coach_clicked');
                window.location.assign(this.LOCAL_HOST+'/forms/contact_wellness_company?e=1108');
            } else if(this.selectedVal == 3){
                this.web_hits('contact_worklife_specialist_legal_financial_clicked');
                if(parseInt(this.callback_forms.chn_url)){
                    window.location.assign(this.LOCAL_HOST+'/forms/callback_work_life_specialist_chn');
                } else {
                    window.location.assign(this.LOCAL_HOST+'/forms/callback_work_life_specialist');
                }
            } else if(this.selectedVal == 4){
                this.web_hits('contact_existing_case_clicked');
                window.location.assign(this.LOCAL_HOST+'/forms/callback_case');
            }
            else if(this.selectedVal == 5){
                this.web_hits('contact_worklife_specialist_provider_locator_clicked');
                if(parseInt(this.callback_forms.chn_url)){
                    window.location.assign(this.LOCAL_HOST+'/forms/callback_work_life_specialist_chn?frmTyp=proloc');
                } else {
                    window.location.assign(this.LOCAL_HOST+'/forms/callback_work_life_specialist?frmTyp=proloc');
                }
            }                  
        },
        getlangVar(){
            var api_private_key=this.get_api_key_mix('lams')
            axios.get(this.$store.state.apiUrl+'/language_terms',{
                params:{
                    id_language:this.$store.state.companyData['id_language'],
                    privatekey:api_private_key,
                    id_company:this.$store.state.companyData['id_company'],
                    id_country:this.$store.state.companyData['id_country']                 
                }
            })
            .then(response => {              
                response = response.data;
                this.lang_detail = response;
                var titleValue =this.lang_detail['connect_with_us'];                
                var home = this.lang_detail['d00'];
                this.$announcer.set(this.decodeHtmlLang(titleValue)+' | '+this.$store.state.companyData['name_company']);
                document.title = this.decodeHtmlLang(titleValue)+' | '+this.$store.state.companyData['name_company'];                  
            })
            .catch(() => {
                this.lang_detail = []
            });
        },
        callback_forms_Check(){
          var api_private_key=this.get_api_key_mix('geig') 
          axios.get(this.$store.state.apiUrl+'/get_callback_form_config',{
              params:{
                  id_language:this.$store.state.companyData['id_language'],
                  id_eap:this.$store.state.companyData['id_eap'],
                  id_company:this.$store.state.companyData['id_company'],
                  id_country:this.$store.state.companyData['id_country'],
                  id_customization:this.company_data['id_customizations'],
                  privatekey:api_private_key
              }
          })
          .then(response => {
              this.callback_forms = response.data;
          })
          .catch(() => {
              this.callback_forms = [];
          });
      },
      getCompanyData(){        
          var api_private_key=this.get_api_key_mix('cofo')
          axios.get(this.$store.state.apiUrl+'/company_info',{
              params:{
                  id_company:this.$store.state.companyData['id_company'] ,
                  id_language:this.$store.state.companyData['id_language'],
                  id_country:this.$store.state.companyData['id_country'],                    
                  privatekey:api_private_key
                  }
              })
          .then(response => {
              response = response.data;
              this.company_data['id_customizations'] = response['id_customizations'];
               this.callback_forms_Check()          
              })
          .catch((error) => {
              this.company_data = [];
              this.company_data['id_customizations']=this.$store.state.companyDataInfo['id_customizations'];
               this.callback_forms_Check() 
              this.customErrorHandler(error.response.status);
              });
      }
    }
};
</script>
<style scoped>
.form-group{
    margin-bottom: 40px;
}
.side{
   margin-left:15px; 
}
.side .submit{
    right: 20px !important;
}
.dynamic_form_error_required{
    padding-left:15px !important;
    color:#FF0000 !important;    
}
.required_indicator {
    font-family: Verdana;
    font-size: 14px;
    color: red;
}
.form-control {
    -webkit-appearance: auto;
    -moz-appearance: auto;
    appearance: auto;
}
.hhcap{
    padding-left: 1em;
}
label{
    padding-top: 18px;
    display:block !important;
}
.frm-radio{
    width: 28px !important;
}
.div-wrap-radio{
    margin-right:18px !important;
}
</style>